module.exports = __webpack_public_path__ + "assets/img/sabc_social_twitter.svg?46256fdae4783e02edb83812eefac33b";